import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-convention-modal',
  templateUrl: './add-convention-modal.component.html',
  styleUrls: ['./add-convention-modal.component.scss']
})
export class AddConventionModalComponent implements OnInit {

  editMode: boolean = false
  form: UntypedFormGroup

  conventions: any = []
  currentConvetionId:any = null

  remove: any = 'removeConvention'

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder
  ) {
    this.form = this.fb.group({
      conventionId: [null, [Validators.required]],
    })

    if (data) {
      //if(data?.conventions.length == 1) this.form.get('conventionId')?.setValue(`${data?.conventions[0].id}`)
      if (data?.conventions) this.conventions = data?.conventions
      if (data?.currentConvetionId){
        this.currentConvetionId = data?.currentConvetionId
        console.log(this.currentConvetionId)
        if(this.currentConvetionId) this.form.get('conventionId')?.setValue(this.currentConvetionId)
      }
    
    }


  }

  ngOnInit(): void {
  }

  clearSubject() {
    console.log('clearSubject')
    this.form?.get('subjectToId')?.setValue(null)
  }

  selSubject(event: any) {
    console.log('Selected: ', event);
    if (event?.id) {
      this.form?.get('subjectToId')?.setValue(event.id)
    }
  }

  requiresApproval(subjectRelationType: any) {
    let requiresApprovalString = ``
    if (subjectRelationType.requiresApproval) requiresApprovalString = 'SUBJECT_RELATION_TYPES.requiresApproval'
    return requiresApprovalString
  }

  disabledRemoveConvetion(){
    let status = true;
    if(this.currentConvetionId != null) status = false;
    return status;
  }

}
